import React from 'react';
import { Tooltip } from 'antd';
import { useTranslation } from '../../_utils/i18n';
import { BillItem, PayBillItem, DisabledText, PromotionValue, ImageQuestionMark, TaxDesc } from './styled';
import { DetailCard, Title3 } from '../../styled';
import { isLaxNull, formatPriceJson, formatApiIntl } from '../../_utils/tool';
import imageQuestionMark from './images/questionMark.svg';
import withI18nAndTheme from '../../_utils/withI18nAndTheme';
import { UpgradeTypeEnum } from '../../constants';
import { useCompatibleForSentry, useSettleAmountFormatter } from '../../hooks';
var BillDetailCard = function BillDetailCard(props) {
  var billDetail = props.billDetail,
    upgradeType = props.upgradeType;
  var _ref = billDetail || {},
    originAmount = _ref.originAmount,
    productCurrency = _ref.productCurrency,
    settleAmount = _ref.settleAmount,
    orderCurrency = _ref.orderCurrency,
    shiftAmount = _ref.shiftAmount,
    discountAmount = _ref.discountAmount,
    totalAmount = _ref.totalAmount,
    promotion = _ref.promotion,
    remainingDays = _ref.remainingDays,
    shiftRemainDays = _ref.shiftRemainDays,
    tax = _ref.tax;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var settleAmountFormatter = useSettleAmountFormatter();

  /** 将传入的sentry实例同步到jotai */
  useCompatibleForSentry(props);

  /**
   * 继承升级时
   * 需求：DY-169 https://shopline.yuque.com/docs/share/45cbb9ca-4597-4479-884c-68e29584fe48?#JfFeV
   */
  var upgradeToolTipText = null;
  if (upgradeType === UpgradeTypeEnum.REPLACE) {
    upgradeToolTipText = t('settlement.bill.note2');
    // 下完单后的账单详情数据的剩余天数
  } else if (!isLaxNull(remainingDays)) {
    upgradeToolTipText = t('settlement.bill.note1', {
      days: remainingDays
    });
    // 未下单后的计价数据的剩余天数
  } else if (!isLaxNull(shiftRemainDays)) {
    upgradeToolTipText = t('settlement.bill.note1', {
      days: shiftRemainDays
    });
  }
  return /*#__PURE__*/React.createElement(DetailCard, null, /*#__PURE__*/React.createElement(Title3, null, t('settlement.bill details')), /*#__PURE__*/React.createElement(BillItem, {
    marginTop: "26px"
  }, /*#__PURE__*/React.createElement("span", null, t('settlement.subtotal')), /*#__PURE__*/React.createElement("span", null, formatPriceJson(originAmount, productCurrency))), !!shiftAmount && /*#__PURE__*/React.createElement(BillItem, null, /*#__PURE__*/React.createElement("span", null, t('subscriptions.packagePay.upgrade'), upgradeToolTipText && /*#__PURE__*/React.createElement(Tooltip, {
    title: upgradeToolTipText
  }, /*#__PURE__*/React.createElement(ImageQuestionMark, {
    src: imageQuestionMark,
    style: {
      marginLeft: 5
    }
  }))), /*#__PURE__*/React.createElement(PromotionValue, null, "- ", formatPriceJson(shiftAmount, productCurrency))), !!discountAmount && /*#__PURE__*/React.createElement(BillItem, null, /*#__PURE__*/React.createElement("span", null, formatApiIntl(promotion === null || promotion === void 0 ? void 0 : promotion.promotionName)), /*#__PURE__*/React.createElement(PromotionValue, null, "- ", formatPriceJson(discountAmount, productCurrency))), !!(shiftAmount || discountAmount) && /*#__PURE__*/React.createElement(BillItem, null, /*#__PURE__*/React.createElement("span", null, t('subscriptions.packagePay.total')), /*#__PURE__*/React.createElement("span", null, formatPriceJson(totalAmount, productCurrency))), tax && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BillItem, null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", null, t('subscriptions.packagePay.Taxrate'))), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", null, formatPriceJson(tax.amount, productCurrency)))), /*#__PURE__*/React.createElement(TaxDesc, null, /*#__PURE__*/React.createElement("span", null, tax.desc), /*#__PURE__*/React.createElement("span", null, "(".concat(tax.rate, "%)")), /*#__PURE__*/React.createElement("span", null, "-#", tax.no))), /*#__PURE__*/React.createElement(PayBillItem, null, /*#__PURE__*/React.createElement("span", null, t('settlement.actual payment')), /*#__PURE__*/React.createElement("span", null, settleAmountFormatter(settleAmount, {
    code: orderCurrency
  }))), productCurrency !== orderCurrency ? /*#__PURE__*/React.createElement(DisabledText, null, t('settlement.note')) : null);
};
export default BillDetailCard;
export var BillDetailCardComponent = withI18nAndTheme(BillDetailCard);